import React, { useEffect, useState, createRef, Fragment } from "react"
import { Link, navigate } from "gatsby"
import { useAnimation, motion, AnimatePresence } from "framer-motion"
import { useInView } from "react-intersection-observer"
import ReCAPTCHA from "react-google-recaptcha";
import { Listbox } from '@headlessui/react'
import { FiChevronDown, FiCheck } from "react-icons/fi";

const motionSection = {
  hidden: {
    opacity: 0,
    y: 20,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      staggerChildren: 0.3,
      staggerDirection: 1,
      delay: 0.3,
      ease: [0.38, 0.005, 0.215, 1],
      when: "beforeChildren",
    },
  },
}
const title = {
  hidden: {
    opacity: 0,
    y: 20,
  },
  visible: {
    opacity: 1,
    // right: 0,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.38, 0.005, 0.215, 1],
    },
  },
}
const underline = {
  hidden: {
    // opacity: 0,
    width: 0,
  },
  visible: {
    opacity: 1,
    // right: 0,
    width: "100%",
    transition: {
      duration: 0.3,
      ease: [0.38, 0.005, 0.215, 1],
    },
  },
}
const motionItems = {
  hidden: {
    opacity: 0,
    y: 20,
    // rotate: 20,
  },
  visible: {
    opacity: 1,
    // right: 0,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.38, 0.005, 0.215, 1],
    },
  },
}



const reasons_list = [ "Billing", "Vaccinations", "Events", "Other" ]

const contactForm = ({ block }) => {
  const { heading, text } = block

  const controls = useAnimation()
  const [ref, inView] = useInView()

  useEffect(() => {
    if (inView) {
      controls.start("visible")
    }
  }, [controls, inView])

  const [selectedReason, setSelectedReason] = useState('')

  const [buttonDisabled, setButtonDisabled] = useState(true)


  const recaptchaRef = createRef()
  const recaptchaKey = process.env.GATSBY_SITE_RECAPTCHA_KEY

  // const [recaptchaValue, setRecaptchaValue] = useState("")

  //form handling
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    reason: "",
    message: "",
    "bot-field": "",
    // "g-recaptcha-response": "",
  })

  // const handleCaptcha = (value) => {
  //   setButtonDisabled(false)
  //   // setRecaptchaValue(value)
  //   setFormData({
  //     ...formData,
  //     "g-recaptcha-response": value,
  //   })
  // }

  const handleChange = e => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })
  }

  console.log("formData", formData)

  //form validations
  const [errors, setErrors] = useState({})

  const validate = formData => {
    let formErrors = {}
    if (!formData.firstName) {
      formErrors.firstName = "First name required"
    }
    if (!formData.lastName) {
      formErrors.lastName = "Last name required"
    }
    if (!formData.email) {
      formErrors.email = "Email required"
    }
    
    if (!formData.reason) {
      formErrors.reason = "Reason is required"
    }
    if (!formData.message) {
      formErrors.message = "Message is required"
    }
    return formErrors
  }

  const [isSubmitted, setIsSubmitted] = useState(false)

  const handleSubmit = e => {
    setErrors(validate(formData))
    setIsSubmitted(true)
    e.preventDefault()
  }

  const encode = data => {
    return Object.keys(data)
      .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
      .join("&")
  }

  useEffect(() => {

    if (Object.keys(errors).length === 0 && isSubmitted) {
      // const recaptchaValue = recaptchaRef.current.getValue();

      fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: 
          encode({ 
            "form-name": "contact-form", 
            ...formData 
          }),
          
        
      })
        // .then(() => alert("Success!"))
        .then(() => setIsSubmitted(false))
        .then(() =>
          setFormData({ firstName: "", lastName: "", email: "", reason: "", message: "", "bot-field": "", })
        )
        .then(() => navigate('/thank-you'))
        .catch(error => alert(error))
    }
  }, [errors, formData, isSubmitted])
  console.log(errors, formData)

  return (
    <motion.section
      ref={ref}
      animate={controls}
      initial="hidden"
      variants={motionSection}
    >
      <div className="p-6 lg:p-12 max-w-screen-md mx-auto">
        {heading && (
          <h2 className="h2 text-center relative w-fit mx-auto mb-8">
            <motion.div variants={title}>{heading}</motion.div>
            <motion.div
              variants={underline}
              className="section-heading__underline bg-orange-400 h-2 w-full absolute -bottom-4 left-0"
            />
          </h2>
        )}
        {text && <p>{text}</p>}

        <form
          name="contact-form"
          method="post"
          className="grid grid-cols-1 gap-6"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
          // data-netlify-recaptcha="true"
          onSubmit={handleSubmit}
        >
          <input className="hidden" name="form-name" value="contact-form" />

          <div className="hidden">
          <input name="bot-field" type="text" onChange={handleChange} />

          </div>
         

          <label className="block">
            <span>First name</span>
            <input
              type="text"
              id="firstName"
              name="firstName"
              className="
                mt-1
                block
                w-full
                rounded-md
                bg-orange-100
                border-transparent
                focus:border-gray-500 focus:bg-white focus:ring-0
              "
              value={formData.firstName}
              onChange={handleChange}
              placeholder=""
              required
            />
            {errors.firstName && <p>{errors.firstName}</p>}
          </label>
          <label className="block">
            <span>Last name</span>
            <input
              type="text"
              id="lastName"
              name="lastName"
              className="
                mt-1
                block
                w-full
                rounded-md
                bg-orange-100
                border-transparent
                focus:border-gray-500 focus:bg-white focus:ring-0
              "
              value={formData.lastName}
              onChange={handleChange}
              placeholder=""
              required
            />
            {errors.lastName && <p>{errors.lastName}</p>}
          </label>
          <label className="block">
            <span>Email address</span>
            <input
              type="email"
              className="
                    mt-1
                    block
                    w-full
                    rounded-md
                    bg-orange-100
                    border-transparent
                    focus:border-gray-500 focus:bg-white focus:ring-0
                  "
              value={formData.email}
              onChange={handleChange}
              placeholder="john@example.com"
              id="email"
              name="email"
              required
            />
            {errors.email && <p>{errors.email}</p>}
          </label>

          <div>
            <p>Reason:</p>
            <select name="reason" id="reason" onChange={handleChange} className=" mt-1 block w-full rounded-md bg-orange-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0 " required>
            <option value="" disabled selected>Select a reason</option>
            {reasons_list.map((reason, index) => (
              <option value={reason}>{reason}</option>
            ))}
          </select>

          {errors.reason && <p className="text-sm mt-1">{errors.reason}</p>}
          </div>
          

          

          <label className="block">
            <span>Message</span>
            <textarea
              type="text"
              className="
                    mt-1
                    block
                    w-full
                    rounded-md
                    bg-orange-100
                    border-transparent
                    focus:border-gray-500 focus:bg-white focus:ring-0
                  "
              id="message"
              name="message"
              rows="3"
              value={formData.message}
              onChange={handleChange}
              required
            />
            {errors.email && <p>{errors.email}</p>}
          </label>

          {/* <ReCAPTCHA 
            ref={recaptchaRef}
            name="g-recaptcha-response"
            sitekey={recaptchaKey}
            onChange={handleCaptcha}
             /> */}


<div data-netlify-recaptcha="true"></div>


          <p>
            <input
              type="submit"
              value="Submit message"
              className="btn-secondary"
            />
          </p>
        </form>
      </div>
    </motion.section>
  )
}

export default contactForm
